export const PENDING = (type) => `${type}_PENDING`;
export const SUCCESS = (type) => `${type}_SUCCESS`;
export const ERROR = (type) => `${type}_ERROR`;
export const TYPES = (type) => [
    PENDING(type),
    SUCCESS(type),
    ERROR(type),
];
//# sourceMappingURL=consts.js.map